module.exports = __webpack_public_path__ + "static/media/3-PEANO.259cc53f.mp3";